import { type MRT_ColumnDef } from "mantine-react-table-open";
import type { Paragraph6GemeindeAnteilErzeugerResponse } from "../../../Paragraph6.types";

export function getGeneratorColumn(): MRT_ColumnDef<Paragraph6GemeindeAnteilErzeugerResponse> {
  return {
    header: "Erzeuger",
    accessorKey: "generator_display_name",
    sortingFn: "alphanumeric"
  };
}
